module.exports = __webpack_public_path__ + "lato-medium-italic-aa1a75124661b40a6770dc0d8274ddaa.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/lato-medium-italic/lato-medium-italic.woff
// module id = 1053
// module chunks = 0